import { useState } from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

interface FAQItemProps {
  question: string;
  answer: React.ReactNode;
  value: string;
}

const faqItems: FAQItemProps[] = [
  {
    question: "How exactly does the Solana Volume Bot work?",
 answer: (
 <>
        The <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Solana Volume Bot</a> is a sophisticated technical visibility enhancement tool designed to increase your token's presence on trending lists and discovery pages. It achieves this by creating distributed on-chain transaction activity. The bot coordinates transactions across multiple wallets using varying amounts and timing intervals, generating natural-looking activity patterns. Our system actively monitors DEX platform algorithms, like those on DEXTools and Pump.fun, and adapts these transaction patterns to optimize your token's visibility. Think of the <strong>Sol Volume Bot</strong> as an SEO tool for your token, working continuously to ensure consistent presence in key discovery areas.
 </>
 ),
    value: "item-1"
  },
  {
 question: "Tell me about the free trial for the Pump Fun Volume Bot.",
 answer: (
 <>
        We offer a comprehensive free trial for the <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Pump Fun Volume Bot</a>, giving you full access for 7 days without any restrictions. Getting started is simple: just enter your token address. There's no credit card or wallet connection required to begin your trial. During this period, you'll have access to our intuitive dashboard, providing real-time analytics on your token's performance across various DEX platforms. If you find the <strong>Solana Volume Bot</strong> beneficial and wish to continue after the trial, you can easily subscribe to any of our flexible packages.
 </>
 ),
    value: "item-2"
  },
  {
    question: "Is the Dextools Volume Bot safe and secure to use?",
 answer: (
 <>
        Yes, the <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Dextools Volume Bot</a> is designed with security as a top priority. Our system operates entirely through API interactions and never requires access to your private keys or wallet seed phrases. We implement military-grade encryption protocols to protect your data and token information. The <strong>Sol Volume Bot</strong> runs on a secure infrastructure with regular security audits to ensure the highest level of protection. Additionally, our anti-detection technology helps ensure that your volume activity appears natural to exchange monitoring systems.
 </>
 ),
    value: "item-3"
  },
  {
    question: "How quickly will my token start trending with the Pump Fun Trending Bot?",
 answer: (
 <>
        Most projects start seeing significant visibility improvements within 24-48 hours of activating the <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Pump Fun Trending Bot</a>. For tokens with existing liquidity and some trading history, our customers typically see their tokens appear on Pump.fun trending lists within the first 24 hours. For DEXTools trending placement, which has a more competitive algorithm, the <strong>Dextools Volume Bot</strong> component typically requires 2-3 days of consistent volume before tokens start appearing on hot pairs lists. Our premium packages are designed to accelerate these timelines through higher volume patterns and specialized algorithms.
 </>
 ),
    value: "item-4"
  },
  {
    question: "How do I configure the Solana Volume Bot for maximum effectiveness?",
 answer: (
 <>
        Configuring the <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Solana Volume Bot</a> for maximum effectiveness is simple using our user-friendly dashboard. You'll start by setting your daily volume targets, which can be based on a specific USD amount or a percentage of your token\'s market cap and liquidity. You can then customize volume patterns to closely match your token\'s natural transaction history. The <strong>Sol Volume Bot</strong> provides options to configure peak activity hours, aligning with your community's most active periods. For enhanced DEXTools optimization, our <strong>Dextools Volume Bot</strong> settings allow you to target specific metrics known to influence trending algorithms. Advanced features like volume distribution curves and multi-DEX targeting are available for premium subscribers.
 </>
 ),
    value: "item-5"
  },
  {
    question: "Can the Pump Fun Volume Bot help with my token launch?",
 answer: (
 <>
        Absolutely! The <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Pump Fun Volume Bot</a> is an ideal tool to support your new token launch. For optimal results, we highly recommend activating the bot immediately after providing initial liquidity. Our specialized launch settings are designed to create a gradual, organic-looking increase in volume, which helps your token gain essential early visibility without triggering exchange monitoring systems. The <strong>Solana Volume Bot</strong> works seamlessly alongside your marketing campaigns, effectively amplifying visibility during key announcements and community events. Many successful projects incorporate our service as a critical part of their launch strategy to quickly achieve trending status on platforms like Pump.fun and DEXTools.
 </>
 ),
    value: "item-6"
  },
  {
    question: "Is the Solana Volume Bot a trading or investment tool?",
 answer: (
 <>
        <strong>No</strong>, it is crucial to understand that the <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Solana Volume Bot</a> is <strong>not</strong> a trading or investment tool. It is exclusively designed as a technical visibility enhancement solution. Our system generates balanced transactions that are intended to maintain a neutral market impact while significantly increasing on-chain activity. This increased activity is solely for the purpose of improving your token's discoverability and helping it appear on trending lists across major DEX platforms like Pump.fun and DEXTools. Think of the <strong>Sol Volume Bot</strong> as a technical marketing solution for your on-chain token, akin to how SEO works for websites. The tool does not offer trading signals, provide investment advice, or make any form of financial recommendations.
 </>
 ),
    value: "item-7"
  },
  {
    question: "How does the Dextools Volume Bot avoid detection?",
 answer: (
 <>
        Our <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">DEXTools Volume Bot</a> employs sophisticated anti-detection systems developed by our experienced team of DeFi experts. To ensure generated volume appears natural, the bot creates realistic patterns by varying transaction sizes, timing intervals, and the blockchain histories of the wallets used. We meticulously analyze genuine volume patterns from successful tokens and replicate these characteristics in the volume we generate. The <strong>Solana Volume Bot</strong> distributes transactions across a network of multiple wallets, making the activity difficult to distinguish from genuine market participation. Our system is also designed to adapt to changes in DEX algorithms, helping your token maintain visibility even when platforms update their trending criteria.
 </>
 ),
    value: "item-8"
  },
  {
    question: "Which DEX platforms does the PUMP.FUN Trending Bot support?",
 answer: (
 <>
        The <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">PUMP.FUN Trending Bot</a> is designed to support all major Solana DEX platforms. While our primary focus for maximizing visibility is on PUMP.FUN and DEXTools, the <strong>Sol Volume Bot</strong> also facilitates transaction execution on platforms like Jupiter, Raydium, and Orca. The volume data generated is then reflected across various tracking platforms, including DEXScreener and CoinGecko. For clients requiring broader reach, our Enterprise package offers extended support for additional platforms and enables customized volume distribution across multiple DEXes simultaneously. It's important to note that all volume activity generated by the <strong>DEXTools Volume Bot</strong> is visible on-chain and contributes directly to your token's overall market presence.
 </>
 ),
    value: "item-9"
  },
  {
    question: "Can I control how much volume the Solana Volume Bot generates?",
 answer: (
 <>
        Yes, you have granular control over the volume settings within the <a href="https://solanavolumebot.io" rel="dofollow" className="text-[#14F195] hover:underline">Solana Volume Bot</a>. Our intuitive dashboard empowers you to set precise daily volume targets, which can be defined as a specific USD amount or as a percentage relative to your token\'s market cap. The <strong>PUMP.FUN Volume Bot</strong> features include adjustable volume patterns, giving you the flexibility to create volume spikes to coincide with key marketing events or to maintain a consistent baseline activity level. You can instantly pause and resume volume generation directly through the dashboard, and our built-in scheduling feature allows you to plan volume changes in advance. Premium subscribers utilizing the <strong>DEXTools Volume Bot</strong> functionality benefit from additional fine-grained controls for maximum customization and strategic volume deployment.
 </>
 ),
    value: "item-10"
  }
];

export function FaqSection() {
  const [visibleFaqs, setVisibleFaqs] = useState(5); // Show 5 by default
  const FAQS_PER_PAGE = 5;

  const handleLoadMore = () => {
    setVisibleFaqs((prev) => Math.min(prev + FAQS_PER_PAGE, faqItems.length));
  };

  return (
    <section id="faq" className="py-20 bg-background/50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
          Frequently Asked{" "}
          <span className="bg-gradient-to-r from-[#00FFA3] to-[#DC1FFF] text-transparent bg-clip-text">
            Questions
          </span>
        </h2>
        
        <div className="max-w-3xl mx-auto bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-10 text-amber-100">
          <p className="text-center">
            <strong>Important Disclaimer:</strong> Solana Volume Bot is a technical visibility enhancement tool, not a financial product. We do not provide investment advice, trading signals, or price manipulation services. Our tool is designed solely to increase token discoverability through legitimate on-chain activity distribution. Results may vary based on market conditions and token parameters.
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-6">
            {faqItems.slice(0, visibleFaqs).map((item) => (
              <AccordionItem 
                key={item.value} 
                value={item.value}
                className="bg-card rounded-xl overflow-hidden border-none shadow-sm"
              >
                <AccordionTrigger className="px-6 py-4 text-lg font-semibold hover:no-underline">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 opacity-80">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
          {visibleFaqs < faqItems.length && (
            <div className="flex justify-center mt-8">
              <button
                onClick={handleLoadMore}
                className="px-6 py-2 rounded-lg bg-gradient-to-r from-[#00FFA3] to-[#DC1FFF] text-black font-bold hover:from-[#DC1FFF] hover:to-[#00FFA3] hover:text-white transition-colors duration-200"
              >
                View More FAQs
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
